import i18n from '../../i18n';
var ContactSalesStrings = {
    pageTitle: function () { return i18n.t('contactSales_pageTitle'); },
    pageSubtitle: function () { return i18n.t('contactSales_pageSubtitle'); },
    leadForm: {
        firstName: {
            label: function () { return i18n.t('contactSales_leadForm_firstName'); },
        },
        lastName: {
            label: function () { return i18n.t('contactSales_leadForm_lastName'); },
        },
        email: {
            label: function () { return i18n.t('contactSales_leadForm_email'); },
        },
        phoneNumber: {
            label: function () { return i18n.t('contactSales_leadForm_phoneNumber'); },
        },
        companyName: {
            label: function () { return i18n.t('contactSales_leadForm_companyName'); },
        },
        companySize: {
            label: function () { return i18n.t('contactSales_company_size'); },
        },
        frequencyOfUse: {
            label: function () { return i18n.t('contactSales_frequency_of_use'); },
            regularBasisOption: function () {
                return i18n.t('contactSales_frequency_of_use_option_regular_basis');
            },
            adhocBasisOption: function () {
                return i18n.t('contactSales_frequency_of_use__option_adhoc_basis');
            },
        },
        primaryCta: {
            text: function () { return i18n.t('contactSales_leadForm_submit'); },
        },
        secondaryCta: {
            text: function () { return i18n.t('contactSales_leadForm_back'); },
        },
        errors: {
            required: function () { return i18n.t('contactSales_leadFormError_required'); },
            invalidEmail: function () { return i18n.t('contactSales_leadFormError_invalidEmail'); },
            invalidPhone: function () { return i18n.t('contactSales_leadFormError_invalidPhone'); },
        },
    },
    thankYouDisplay: {
        title: function () { return i18n.t('contactSales_thankYou_title'); },
        body: function () { return i18n.t('contactSales_thankYou_body'); },
        adHocBody: function () { return i18n.t('contactSales_thankYou_adhoc_body'); },
    },
    leadFormErrorMessage: function () {
        return i18n.t('contactSales_leadFormError_submissionNotSuccessful');
    },
};
export default ContactSalesStrings;
